import styled from 'styled-components'

import { DropzoneWithUrlUnstyled } from './unstyled'

export const DropzoneWithUrl = styled(DropzoneWithUrlUnstyled)`
  img {
    display: inline-block;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/DropzoneWithUrl/index.js